import contractualInformationSlice from './contractualInformationSlice';

export { default as contractual_informationOp } from './operations';

export default contractualInformationSlice;
